// extracted by css-extract-rspack-plugin
export default {"BranchInfoBarContainer":"BranchInfoBar-module__BranchInfoBarContainer__xZHyz","Box":"BranchInfoBar-module__Box__JQ0ic"};